export default "__VITE_ASSET__7wmcjlUQ__"